(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1538],{

/***/ 75079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./common/data/bank_country.json
var bank_country = __webpack_require__(55881);
// EXTERNAL MODULE: ./common/data/bank_emis.json
var bank_emis = __webpack_require__(33148);
// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/templates/common/open-bank-account/index.js + 1 modules
var open_bank_account = __webpack_require__(53001);
;// CONCATENATED MODULE: ./pages/offshore/company-formation/mauritius/open-bank-account/data.json
var data_namespaceObject = JSON.parse('{"country":"Mauritius","imgAlt":"open a bank account for Mauritius company","breadcrumbs":[{"title":"Company Formation","uri":"/company-formation"},{"title":"Mauritius","uri":"/company-formation/mauritius"},{"title":"Open bank account","uri":"/company-formation/mauritius/open-bank-account"}],"dataPageType":[{"title":"Company Formation","uri":"/company-formation/mauritius"},{"title":"Open Bank Account","uri":"/company-formation/mauritius/open-bank-account"},{"title":"Other Services","uri":"/company-formation/mauritius/other-services"}],"dataHowToOpen":{"title":"How to open a corporate bank account in Mauritius","content":["<p>One initial step to start your offshore business venture is to apply for a ​business bank account. This allows business owners to keep their business depositing and expenditure separate from personal accounts, meaning better limited liability protection and enhanced credibility for your business. As for Mauritius company, there are common application choices to open your business account:</p>","<h3 class=\'font-medium text-bbc-brand-700\'>Applying in a local bank in Mauritius</h3>","<p>Bank of Mauritius and Financial Services Commissions are two mandated bodies responsible for bank and non-bank financial service industry. The country has a well-regulated banking system with a risk-based supervisory framework including a strict AML/CFT legislation in place.</p>","<p>Mauritius has a large, bank-dominated financial sector. Overall, the financial sector contributes approximately 10% to GDP. Banking licenses are granted under Banking Act 2004, which allows banks to carry out both domestic and offshore bank activities. As of Jun 2018, there are 5 domestically-owned banks, 13 subsidiaries of foreign banks, 4 branches of foreign banks and 1 domestic/foreign joint venture, all constitute to 23 financial institutions. The five largest banks account for two-thirds of total assets.</p>","<p>Mauritius Banks offer an extensive range of services for offshore corporations i.e. multi-currency accounts, cross-border transactions, debit/credit card, internet banking, etc.</p>","<h3 class=\'font-medium text-bbc-brand-700\'>Going for offshore bank accounts or fintech solutions</h3>","<p>The good news is that a Mauritius company is not obliged to open a business account in the jurisdictions. It can open its account in any other offshore jurisdiction.</p>"]},"dataRequiredDocument":{"note":"","button":{"type":"talk-to","text":"Talk To Our Expert"},"content":[{"title":"We can support you opening company bank accounts in Mauritius or any proper offshore jurisdictions. Different banks will have unique requirements on a case-by-case basis. Some of the most common documents are presented below for your review:","listContent":[{"text":"Account application form","content":[]},{"text":"Bank statements","content":[]},{"text":"Bank reference letter","content":[]},{"text":"Business proofs (sales/purchase orders, invoice, contract…)","content":[]},{"text":"Certified copies of valid passport, recent address proof within 3 months for all directors/shareholders/account signatories","content":[]},{"text":"Business plan","content":[]},{"text":"Certified copies of Mauritius GBC company documents i.e. CoI, M&AA, Registers of directors/shareholders…","content":[]},{"text":"Certificate of Good Standing/Certificate of Incumbency.","content":[]}]},{"title":"<em>Please contact BBCIncorp to know the exact documents needed for your case.</em>"}]}}');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/offshore/company-formation/mauritius/open-bank-account/index.js






var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "offshore",
    navLight: true,
    page: data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(open_bank_account/* default */.Z, {
      data: data,
      dataJson: data_namespaceObject,
      dataBank: {
        traditional: bank_country/* mauritius */.eD,
        emi: bank_emis/* mauritius */.eD
      }
    })
  });
}

/***/ }),

/***/ 61947:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/company-formation/mauritius/open-bank-account",
      function () {
        return __webpack_require__(75079);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,9973,5955,9131,4090,9738,7447,2864,58,5881,5999,6618,2888,179], function() { return __webpack_exec__(61947); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);